import styled from 'styled-components';

export const HealthInsuranceNumberWrapper = styled.div`
  margin-top: 24px;

  & > div:first-child {
    margin-bottom: 16px;
  }
`;

export const FormListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormItemsWrapper = styled.div`
  display: flex;
  gap: 12px;
  .ant-btn {
    padding: 0;
  }

  & > div:first-child {
    width: 124px;
  }
  
  .ant-select {
    width: 168px
  }

  ${({ isVisibleDelete }: { isVisibleDelete: boolean }) =>
    isVisibleDelete &&
    `
    & > div:last-child {
        align-self: flex-start;
        margin-top: 33px;
        cursor: pointer;
    }
 `}
`;
